import { ApplicationStatus, IUserApplication } from '@/typings';

const COMPLETED_STATUSES = [
  ApplicationStatus.SubmittedToGemini,
  ApplicationStatus.InValidation,
  ApplicationStatus.Verified,
];

/** User applications still awaiting provider action (not yet submitted, in validation, or verified). */
export const getPendingUserApplications = (
  userApplications: IUserApplication[],
): IUserApplication[] =>
  userApplications.filter(
    application => !COMPLETED_STATUSES.includes(application.status),
  );
